import OnTapSubscribeModal from './OnTapSubscribeModal';

export default OnTapSubscribeModal;
